import { SendDeliveryItem } from '@features/send/types';
import { Clip } from '../types';

export const mapClipToSendableItem = (clip: Clip): SendDeliveryItem => ({
    id: parseInt(clip.mediaObjectId, 10),
    name: clip.clipName,
    hasProxy: clip.hasProxy,
    isValid: true,
});
